export const getWaveSectionContent = () => ({
  divider: {
    imageUrl: 'buyers/wave/wave-divider.png',
  },
});
